import React, { Component } from "react";
import {
    Input,
    Table,
    Segment,
    Form,
    Checkbox,
    TextArea,
    Button,
    Modal,
} from "semantic-ui-react";
import { format } from "date-fns";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import NotificationActions from "../../../store/actions/notification";
import ValidationActions from "../../../store/actions/validation";
import NumberInput from "../../../assets/components/NumberInput";
import CourseCreditPricing from "../../../assets/components/golfClub/CourseCreditPricing";
import CourseCreditAvailability from "../../../assets/components/golfClub/CourseCreditAvailability";
import GolfCourse from "../../../models/GolfCourse";
import PartnerClubContract from "../../../models/PartnerClubContract";
import GroupSearchSelect from "../GroupSearchSelect";
import { Tabs, Tab } from "react-bootstrap";

class Courses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: null,
            saving: false,
            editorOpen: false,
            activePricingMonth: 1,

            copyHourModalOpen: false,
            copyHourContext: null, // { month, day, hour }
            copyHourTargets: [], // array of hours (numbers)

            copyDayModalOpen: false,
            copyDayContext: null, // { month, day }
            copyDayTargets: [], // array of days (numbers 1..7)

            copyMonthModalOpen: false,
            copyMonthContext: null, // { month }
            copyMonthTargets: [], // array of months (numbers 1..12)
            hideEmptyHours: true, // ✅ default: hide empty hour rows
        };

        this.daysOfWeek = [
            {
                key: 0,
                value: "monday",
                text: "Monday",
            },
            {
                key: 1,
                value: "tuesday",
                text: "Tuesday",
            },
            {
                key: 2,
                value: "wednesday",
                text: "Wednesday",
            },
            {
                key: 3,
                value: "thursday",
                text: "Thursday",
            },
            {
                key: 4,
                value: "friday",
                text: "Friday",
            },
            {
                key: 5,
                value: "saturday",
                text: "Saturday",
            },
            {
                key: 6,
                value: "sunday",
                text: "Sunday",
            },
        ];

        this.daysOfWeekMatrix = [
            { key: 1, value: 1, text: "Monday" },
            { key: 2, value: 2, text: "Tuesday" },
            { key: 3, value: 3, text: "Wednesday" },
            { key: 4, value: 4, text: "Thursday" },
            { key: 5, value: 5, text: "Friday" },
            { key: 6, value: 6, text: "Saturday" },
            { key: 7, value: 7, text: "Sunday" },
        ];

        this.months = [
            { key: 1, value: 1, text: "Jan" },
            { key: 2, value: 2, text: "Feb" },
            { key: 3, value: 3, text: "Mar" },
            { key: 4, value: 4, text: "Apr" },
            { key: 5, value: 5, text: "May" },
            { key: 6, value: 6, text: "Jun" },
            { key: 7, value: 7, text: "Jul" },
            { key: 8, value: 8, text: "Aug" },
            { key: 9, value: 9, text: "Sep" },
            { key: 10, value: 10, text: "Oct" },
            { key: 11, value: 11, text: "Nov" },
            { key: 12, value: 12, text: "Dec" },
        ];

        this.memberships = ["country", "links", "club"];
    }

    componentWillUnmount() {
        this.props.dispatch(NotificationActions.remove());
        this.props.dispatch(ValidationActions.remove());
    }

    notification(type, text) {
        this.props.dispatch(NotificationActions.create({ type, text }));
    }

    errorsFor(field) {
        if (this.props.validation !== null) {
            if (typeof this.props.validation[field] !== "undefined") {
                return (
                    <span className='has-error'>
                        {" "}
                        {this.props.validation[field][0]}{" "}
                    </span>
                );
            }
        }
    }

    handleValidationErrors(error) {
        if (error.response.status === 422) {
            this.props.dispatch(
                ValidationActions.create(error.response.data.errors),
            );
        }
    }

    gatherInput(property, value) {
        const { editing } = this.state;
        editing[property] = value;
        this.setState({ editing });
    }

    onChangeMatrixPrice(month, day, hour, membership, value) {
        const { editing } = this.state;
        editing.pricingMatrix[month][day][hour][membership].price = value;

        // invariant: null/empty price => creditBookable false
        if (value === null || value === "" || typeof value === "undefined") {
            editing.pricingMatrix[month][day][hour][
                membership
            ].creditBookable = false;
        }

        this.setState({ editing });
    }

    onToggleMatrixCreditBookable(month, day, hour, membership, checked) {
        const { editing } = this.state;
        const cell = editing.pricingMatrix[month][day][hour][membership];

        // invariant: can't enable creditBookable without a price
        if (
            cell.price === null ||
            cell.price === "" ||
            typeof cell.price === "undefined"
        ) {
            cell.creditBookable = false;
        } else {
            cell.creditBookable = checked === true;
        }

        this.setState({ editing });
    }

    onChangeMonthPoa(month, checked) {
        const { editing } = this.state;
        editing.pricingMatrix[month].poa = checked === true;
        this.setState({ editing });
    }

    onChangeMonthHighest(month, value) {
        const { editing } = this.state;
        editing.pricingMatrix[month].highest = value;
        this.setState({ editing });
    }

    formatHourLabel(hour, multiline = false) {
        const pad = (n) => String(n).padStart(2, "0");

        if (multiline) {
            return (
                <>
                    {pad(hour)}:00{multiline && <br />}-{multiline && <br />}
                    {pad(hour)}:59
                </>
            );
        }

        return `${pad(hour)}:00 - ${pad(hour)}:59`;
    }

    deleteCourse(index) {
        const confirm = window.confirm(
            "Are you sure you want to delete this course?",
        );
        if (confirm === true) {
            const { club } = this.props;
            const course = club.courses[index];
            course
                .delete()
                .then((result) => {
                    this.setState({ editing: null });
                    this.notification("success", "Course deleted");
                    club.courses.splice(index, 1);
                    this.props.update(club);
                })
                .catch((error) => {
                    this.notification("success", "Faield to delete course");
                });
        }
    }

    onCopyDayColumn(month, day) {
        this.setState({
            copyDayModalOpen: true,
            copyDayContext: { month, day },
            copyDayTargets: [],
        });
    }

    closeCopyDayModal() {
        this.setState({
            copyDayModalOpen: false,
            copyDayContext: null,
            copyDayTargets: [],
        });
    }

    toggleCopyDayTarget(targetDay) {
        const current = new Set(this.state.copyDayTargets);
        if (current.has(targetDay)) current.delete(targetDay);
        else current.add(targetDay);

        this.setState({
            copyDayTargets: Array.from(current).sort((a, b) => a - b),
        });
    }

    setCopyDayTargets(days) {
        const { copyDayContext } = this.state;
        if (!copyDayContext) return;

        const sourceDay = copyDayContext.day;

        const filtered = days
            .filter((d) => d >= 1 && d <= 7)
            .filter((d) => d !== sourceDay);

        const uniqueSorted = Array.from(new Set(filtered)).sort(
            (a, b) => a - b,
        );

        this.setState({ copyDayTargets: uniqueSorted });
    }

    selectCopyMonThuDays() {
        this.setCopyDayTargets([1, 2, 3, 4]);
    }

    selectCopyMonFriDays() {
        this.setCopyDayTargets([1, 2, 3, 4, 5]);
    }

    selectCopyFriSunDays() {
        this.setCopyDayTargets([5, 6, 7]);
    }

    selectCopySatSunDays() {
        this.setCopyDayTargets([6, 7]);
    }

    selectCopyAllDays() {
        this.setCopyDayTargets([1, 2, 3, 4, 5, 6, 7]);
    }

    clearCopyDayTargets() {
        this.setState({ copyDayTargets: [] });
    }
    isGroupCreditAvailableForDay(dayNumber) {
        const groupAvailability = this.state.editing?.group?.availability;
        if (!groupAvailability) return true; // if unknown, don't hide anything

        const dayKey =
            this.daysOfWeekMatrix
                .find((d) => d.value === dayNumber)
                ?.text?.toLowerCase() ?? null;

        // safer: use mapping rather than text
        const map = {
            1: "monday",
            2: "tuesday",
            3: "wednesday",
            4: "thursday",
            5: "friday",
            6: "saturday",
            7: "sunday",
        };

        const key = map[dayNumber];
        if (!key) return true;

        return (groupAvailability?.[key] ?? 1) !== 0;
    }
    applyCopyDay() {
        const visibleMemberships = this.getVisibleMemberships();
        const { editing, copyDayContext, copyDayTargets } = this.state;
        if (!editing || !copyDayContext || copyDayTargets.length === 0) {
            return this.closeCopyDayModal();
        }

        const { month, day: sourceDay } = copyDayContext;

        const srcDayBlock = editing.pricingMatrix?.[month]?.[sourceDay];
        if (!srcDayBlock) return this.closeCopyDayModal();

        copyDayTargets.forEach((targetDay) => {
            for (let hour = 0; hour <= 23; hour++) {
                visibleMemberships.forEach((membership) => {
                    const srcCell = srcDayBlock?.[hour]?.[membership] ?? {
                        price: null,
                        creditBookable: false,
                    };

                    const price = srcCell.price ?? null;
                    const creditBookable =
                        price === null
                            ? false
                            : srcCell.creditBookable === true;

                    editing.pricingMatrix[month][targetDay][hour][membership] =
                        {
                            price,
                            creditBookable,
                        };
                });
            }
        });

        this.setState({ editing }, () => this.closeCopyDayModal());
    }

    onCopyHourCell(month, day, hour) {
        this.setState({
            copyHourModalOpen: true,
            copyHourContext: { month, day, hour },
            copyHourTargets: [],
        });
    }

    onCopyMonth(month) {
        this.setState({
            copyMonthModalOpen: true,
            copyMonthContext: { month },
            copyMonthTargets: [],
        });
    }

    closeCopyMonthModal() {
        this.setState({
            copyMonthModalOpen: false,
            copyMonthContext: null,
            copyMonthTargets: [],
        });
    }

    toggleCopyMonthTarget(targetMonth) {
        const current = new Set(this.state.copyMonthTargets);
        if (current.has(targetMonth)) current.delete(targetMonth);
        else current.add(targetMonth);

        this.setState({
            copyMonthTargets: Array.from(current).sort((a, b) => a - b),
        });
    }

    setCopyMonthTargets(months) {
        const { copyMonthContext } = this.state;
        if (!copyMonthContext) return;

        const sourceMonth = copyMonthContext.month;

        const filtered = months
            .filter((m) => m >= 1 && m <= 12)
            .filter((m) => m !== sourceMonth);

        const uniqueSorted = Array.from(new Set(filtered)).sort(
            (a, b) => a - b,
        );

        this.setState({ copyMonthTargets: uniqueSorted });
    }

    selectCopyWinterMonths() {
        // 1-3 & 11-12
        this.setCopyMonthTargets([1, 2, 3, 11, 12]);
    }

    selectCopySummerMonths() {
        // 4-10
        this.setCopyMonthTargets([4, 5, 6, 7, 8, 9, 10]);
    }

    selectCopyAllMonths() {
        this.setCopyMonthTargets([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    }

    clearCopyMonthTargets() {
        this.setState({ copyMonthTargets: [] });
    }

    applyCopyMonth() {
        const visibleMemberships = this.getVisibleMemberships();
        const { editing, copyMonthContext, copyMonthTargets } = this.state;
        if (!editing || !copyMonthContext || copyMonthTargets.length === 0) {
            return this.closeCopyMonthModal();
        }

        const { month: sourceMonth } = copyMonthContext;

        const srcMonthBlock = editing.pricingMatrix?.[sourceMonth];
        if (!srcMonthBlock) return this.closeCopyMonthModal();

        // Deep copy month-level meta + all day/hour/membership values
        copyMonthTargets.forEach((targetMonth) => {
            const targetBlock = editing.pricingMatrix?.[targetMonth];
            if (!targetBlock) return;

            // Month meta (keep structure, overwrite values)
            targetBlock.poa = srcMonthBlock.poa === true;
            targetBlock.highest = srcMonthBlock.highest ?? null;
            if (typeof srcMonthBlock.lowest !== "undefined") {
                targetBlock.lowest = srcMonthBlock.lowest ?? null;
            }

            // Days 1..7
            for (let day = 1; day <= 7; day++) {
                // Hours 0..23
                for (let hour = 0; hour <= 23; hour++) {
                    visibleMemberships.forEach((membership) => {
                        const srcCell = srcMonthBlock?.[day]?.[hour]?.[
                            membership
                        ] ?? {
                            price: null,
                            creditBookable: false,
                        };

                        const price = srcCell.price ?? null;
                        const creditBookable =
                            price === null
                                ? false
                                : srcCell.creditBookable === true;

                        editing.pricingMatrix[targetMonth][day][hour][
                            membership
                        ] = {
                            price,
                            creditBookable,
                        };
                    });
                }
            }

            // NOTE: we intentionally do NOT recompute month "lowest" here.
            // If you store month.lowest as derived data, you can recompute server-side on save.
        });

        this.setState({ editing }, () => this.closeCopyMonthModal());
    }
    closeCopyHourModal() {
        this.setState({
            copyHourModalOpen: false,
            copyHourContext: null,
            copyHourTargets: [],
        });
    }
    renderCopyMonthModal() {
        const {
            editing,
            copyMonthModalOpen,
            copyMonthContext,
            copyMonthTargets,
        } = this.state;

        if (!copyMonthModalOpen || !editing || !copyMonthContext) return null;

        const { month } = copyMonthContext;

        const monthName =
            this.months.find((m) => m.value === month)?.text ?? "Month";

        const availableMonths = this.months
            .map((m) => m.value)
            .filter((m) => m !== month);

        return (
            <Modal
                open={copyMonthModalOpen}
                onClose={() => this.closeCopyMonthModal()}
                size='small'
                closeOnDimmerClick={false}
            >
                <Modal.Header>Copy {monthName} to other Months</Modal.Header>

                <Modal.Content>
                    <div style={{ marginTop: 4 }}>
                        <b>Copy to Months</b>

                        <div
                            style={{
                                marginTop: 8,
                                display: "flex",
                                gap: 8,
                                flexWrap: "wrap",
                            }}
                        >
                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyWinterMonths()}
                            >
                                Winter
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopySummerMonths()}
                            >
                                Summer
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyAllMonths()}
                            >
                                Select all
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.clearCopyMonthTargets()}
                            >
                                Clear
                            </Button>
                        </div>

                        <div style={{ marginTop: 12 }}>
                            {availableMonths.map((m) => {
                                const label =
                                    this.months.find((x) => x.value === m)
                                        ?.text ?? `Month ${m}`;

                                return (
                                    <div key={m} style={{ padding: "4px 0" }}>
                                        <Checkbox
                                            label={label}
                                            checked={copyMonthTargets.includes(
                                                m,
                                            )}
                                            onChange={() =>
                                                this.toggleCopyMonthTarget(m)
                                            }
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Modal.Content>

                <Modal.Actions>
                    <Button onClick={() => this.closeCopyMonthModal()}>
                        Cancel
                    </Button>

                    <Button
                        primary
                        className='theme'
                        disabled={copyMonthTargets.length === 0}
                        onClick={() => this.applyCopyMonth()}
                    >
                        Copy
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
    renderCopyDayModal() {
        const { editing, copyDayModalOpen, copyDayContext, copyDayTargets } =
            this.state;

        if (!copyDayModalOpen || !editing || !copyDayContext) return null;

        const { month, day } = copyDayContext;

        const dayName = this.daysOfWeekMatrix.find(
            (d) => d.value === day,
        )?.text;

        const availableDays = this.daysOfWeekMatrix
            .map((d) => d.value)
            .filter((d) => d !== day); // exclude source day

        return (
            <Modal
                open={copyDayModalOpen}
                onClose={() => this.closeCopyDayModal()}
                size='small'
                closeOnDimmerClick={false}
            >
                <Modal.Header>Copy {dayName} to other Days</Modal.Header>

                <Modal.Content>
                    <div style={{ marginTop: 4 }}>
                        <b>Copy to Days</b>

                        <div
                            style={{
                                marginTop: 8,
                                display: "flex",
                                gap: 8,
                                flexWrap: "wrap",
                            }}
                        >
                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyMonThuDays()}
                            >
                                Mon-Thu
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyMonFriDays()}
                            >
                                Mon-Fri
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyFriSunDays()}
                            >
                                Fri-Sun
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopySatSunDays()}
                            >
                                Sat-Sun
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyAllDays()}
                            >
                                Select all
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.clearCopyDayTargets()}
                            >
                                Clear
                            </Button>
                        </div>

                        <div style={{ marginTop: 12 }}>
                            {availableDays.map((d) => {
                                const label =
                                    this.daysOfWeekMatrix.find(
                                        (x) => x.value === d,
                                    )?.text ?? `Day ${d}`;

                                return (
                                    <div key={d} style={{ padding: "4px 0" }}>
                                        <Checkbox
                                            label={label}
                                            checked={copyDayTargets.includes(d)}
                                            onChange={() =>
                                                this.toggleCopyDayTarget(d)
                                            }
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Modal.Content>

                <Modal.Actions>
                    <Button onClick={() => this.closeCopyDayModal()}>
                        Cancel
                    </Button>

                    <Button
                        primary
                        className='theme'
                        disabled={copyDayTargets.length === 0}
                        onClick={() => this.applyCopyDay()}
                    >
                        Copy
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    toggleCopyHourTarget(targetHour) {
        const current = new Set(this.state.copyHourTargets);
        if (current.has(targetHour)) current.delete(targetHour);
        else current.add(targetHour);

        this.setState({
            copyHourTargets: Array.from(current).sort((a, b) => a - b),
        });
    }

    applyCopyHour() {
        const visibleMemberships = this.getVisibleMemberships();
        const { editing, copyHourContext, copyHourTargets } = this.state;
        if (!editing || !copyHourContext || copyHourTargets.length === 0) {
            return this.closeCopyHourModal();
        }

        const { month, day, hour: sourceHour } = copyHourContext;

        const src = editing.pricingMatrix?.[month]?.[day]?.[sourceHour];
        if (!src) return this.closeCopyHourModal();

        copyHourTargets.forEach((targetHour) => {
            visibleMemberships.forEach((membership) => {
                const srcCell = src?.[membership] ?? {
                    price: null,
                    creditBookable: false,
                };

                const price = srcCell.price ?? null;
                const creditBookable =
                    price === null ? false : srcCell.creditBookable === true;

                editing.pricingMatrix[month][day][targetHour][membership] = {
                    price,
                    creditBookable,
                };
            });
        });

        this.setState({ editing }, () => this.closeCopyHourModal());
    }

    getMembershipLabelShort(membership) {
        return membership === "country"
            ? "Country"
            : membership === "links"
            ? "Links"
            : "Club";
    }

    getMonthLabel(month) {
        return (
            this.months.find((m) => m.value === month)?.text ?? `Month ${month}`
        );
    }
    setCopyHourTargets(hours) {
        const { copyHourContext } = this.state;
        if (!copyHourContext) return;

        const sourceHour = copyHourContext.hour;
        const filtered = hours
            .filter((h) => h >= 0 && h <= 23)
            .filter((h) => h !== sourceHour);

        // unique + sorted
        const uniqueSorted = Array.from(new Set(filtered)).sort(
            (a, b) => a - b,
        );

        this.setState({ copyHourTargets: uniqueSorted });
    }

    selectCopyAllHours() {
        this.setCopyHourTargets(Array.from({ length: 24 }, (_, h) => h));
    }

    selectCopyAMHours() {
        // 06:00 - 11:59
        this.setCopyHourTargets(Array.from({ length: 6 }, (_, i) => i + 6)); // 6..11
    }

    selectCopyPMHours() {
        // 12:00 - 17:59
        this.setCopyHourTargets(Array.from({ length: 6 }, (_, i) => i + 12)); // 12..17
    }

    selectCopyDaytimeHours() {
        // Daytime = 06:00 - 17:59
        this.setCopyHourTargets(Array.from({ length: 12 }, (_, i) => i + 6)); // 6..17
    }

    selectCopyMorningAndEveningHours() {
        // Morning = 00:00 - 05:59, Evening = 18:00 - 23:59
        const morning = Array.from({ length: 6 }, (_, h) => h); // 0..5
        const evening = Array.from({ length: 6 }, (_, i) => i + 18); // 18..23
        this.setCopyHourTargets([...morning, ...evening]);
    }

    isHourCellEmpty(monthBlock, day, hour) {
        const visibleMemberships = this.getVisibleMemberships();

        for (const membership of visibleMemberships) {
            const cell = monthBlock?.[day]?.[hour]?.[membership];

            const price = cell?.price ?? null;
            const hasPrice = !(
                price === null ||
                price === "" ||
                typeof price === "undefined"
            );

            const hasCredit = cell?.creditBookable === true;

            if (hasPrice || hasCredit) {
                return false;
            }
        }

        return true;
    }

    isHourFullyEmpty(monthBlock, hour) {
        for (let day = 1; day <= 7; day++) {
            for (const membership of this.memberships) {
                const cell = monthBlock?.[day]?.[hour]?.[membership];

                const price = cell?.price ?? null;
                const hasPrice = !(
                    price === null ||
                    price === "" ||
                    typeof price === "undefined"
                );

                const hasCredit = cell?.creditBookable === true;

                if (hasPrice || hasCredit) return false;
            }
        }

        return true;
    }

    isDayFullyEmpty(monthBlock, day) {
        for (let hour = 0; hour <= 23; hour++) {
            for (const membership of this.memberships) {
                const cell = monthBlock?.[day]?.[hour]?.[membership];

                const price = cell?.price ?? null;
                const hasPrice = !(
                    price === null ||
                    price === "" ||
                    typeof price === "undefined"
                );

                const hasCredit = cell?.creditBookable === true;

                if (hasPrice || hasCredit) return false;
            }
        }

        return true;
    }

    getVisibleMemberships() {
        const roles = this.props.club?.showForRoles;

        // If not set, default to showing everything (backwards compatible)
        if (!Array.isArray(roles) || roles.length === 0)
            return this.memberships;

        const map = {
            country: "MASHIE_COUNTRY_MEMBERSHIP",
            links: "MASHIE_LINKS_MEMBERSHIP",
            club: "MASHIE_CLUB_MEMBERSHIP",
        };

        return this.memberships.filter((m) => roles.includes(map[m]));
    }

    clearCopyHourTargets() {
        this.setState({ copyHourTargets: [] });
    }
    renderCopyHourModal() {
        const visibleMemberships = this.getVisibleMemberships();
        const { editing, copyHourModalOpen, copyHourContext, copyHourTargets } =
            this.state;
        if (!copyHourModalOpen || !editing || !copyHourContext) return null;

        const { month, day, hour } = copyHourContext;
        const monthBlock = editing.pricingMatrix?.[month];
        const src = monthBlock?.[day]?.[hour];

        if (!src) return null;

        const currencySymbol = this.props.club?.currency?.symbol ?? "£";

        const availableHours = Array.from({ length: 24 }, (_, h) => h).filter(
            (h) => h !== hour,
        );

        return (
            <Modal
                open={copyHourModalOpen}
                onClose={() => this.closeCopyHourModal()}
                size='small'
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    Copy {this.formatHourLabel(hour)} to{" "}
                    {this.daysOfWeekMatrix.find((d) => d.value === day)?.text}{" "}
                    Timeslots
                </Modal.Header>

                <Modal.Content>
                    <div style={{ marginBottom: 12 }}>
                        <b>Selected hour values</b>
                        <div style={{ marginTop: 8 }}>
                            {visibleMemberships.map((membership) => {
                                const cell = src?.[membership] ?? {
                                    price: null,
                                    creditBookable: false,
                                };
                                const price = cell.price ?? null;
                                const cb = cell.creditBookable === true;

                                return (
                                    <div
                                        key={membership}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            padding: "6px 0",
                                            borderBottom:
                                                "1px solid rgba(0,0,0,0.06)",
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>
                                            {this.getMembershipLabelShort(
                                                membership,
                                            )}
                                        </span>

                                        <span style={{ opacity: 0.9 }}>
                                            {price === null
                                                ? "—"
                                                : `${currencySymbol}${price}`}
                                            {cb
                                                ? " - Green Fee Credit Enabled"
                                                : ""}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div style={{ marginTop: 12 }}>
                        <b>Copy to hours</b>

                        <div
                            style={{
                                marginTop: 8,
                                display: "flex",
                                gap: 8,
                                flexWrap: "wrap",
                            }}
                        >
                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyAllHours()}
                            >
                                All hours
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyAMHours()}
                            >
                                AM
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyPMHours()}
                            >
                                PM
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.selectCopyDaytimeHours()}
                            >
                                Daytime
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() =>
                                    this.selectCopyMorningAndEveningHours()
                                }
                            >
                                Morning & Evening
                            </Button>

                            <Button
                                size='mini'
                                basic
                                onClick={() => this.clearCopyHourTargets()}
                            >
                                Clear
                            </Button>
                        </div>

                        <div style={{ marginTop: 8 }}>
                            {availableHours.map((h) => (
                                <div key={h} style={{ padding: "4px 0" }}>
                                    <Checkbox
                                        label={this.formatHourLabel(h)}
                                        checked={copyHourTargets.includes(h)}
                                        onChange={() =>
                                            this.toggleCopyHourTarget(h)
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Content>

                <Modal.Actions>
                    <Button onClick={() => this.closeCopyHourModal()}>
                        Cancel
                    </Button>

                    <Button
                        primary
                        className='theme'
                        disabled={copyHourTargets.length === 0}
                        onClick={() => this.applyCopyHour()}
                    >
                        Copy
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    renderMembershipRow({
        month,
        day,
        hour,
        membership,
        cell,
        currencyIcon,
        hasContracts,
        showCreditCheckbox,
    }) {
        return (
            <div
                key={membership}
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 4,
                    whiteSpace: "nowrap",
                }}
            >
                <div style={{ flex: 1, minWidth: 90 }}>
                    <NumberInput
                        icon={currencyIcon}
                        nullable
                        min={1}
                        value={cell?.price ?? ""}
                        onChange={(value) =>
                            this.onChangeMatrixPrice(
                                month,
                                day,
                                hour,
                                membership,
                                value,
                            )
                        }
                        fluid
                        iconPosition='left'
                        decimal
                        placeholder=''
                    />
                </div>

                {hasContracts && showCreditCheckbox && (
                    <Checkbox
                        checked={cell?.creditBookable === true}
                        onChange={(_, { checked }) =>
                            this.onToggleMatrixCreditBookable(
                                month,
                                day,
                                hour,
                                membership,
                                checked,
                            )
                        }
                        disabled={
                            cell?.price === null ||
                            cell?.price === "" ||
                            typeof cell?.price === "undefined"
                        }
                    />
                )}
            </div>
        );
    }
    buildHoursWithGaps(monthBlock) {
        const isHidden = (h) =>
            this.state.hideEmptyHours === true &&
            this.isHourFullyEmpty(monthBlock, h);

        const rows = [];
        let gapStart = null;

        for (let h = 0; h <= 23; h++) {
            if (isHidden(h)) {
                if (gapStart === null) gapStart = h;
                continue;
            }

            // flush any pending gap before a visible hour
            if (gapStart !== null) {
                rows.push({
                    type: "gap",
                    from: gapStart,
                    to: h - 1,
                });
                gapStart = null;
            }

            rows.push({ type: "hour", hour: h });
        }

        // flush gap at the end of the day
        if (gapStart !== null) {
            rows.push({ type: "gap", from: gapStart, to: 23 });
        }

        return rows;
    }
    renderMonthPricingMatrix(month) {
        const { editing } = this.state;
        const currencyIcon = this.showCorrectCurrency();
        const monthBlock = editing.pricingMatrix?.[month];
        const hasContracts = (editing.contracts?.length ?? 0) > 0;
        const visibleMemberships = this.getVisibleMemberships();

        if (!monthBlock) return <p>Pricing matrix not available.</p>;
        const rowsToRender = this.buildHoursWithGaps(monthBlock);
        const poaActive = monthBlock.poa === true;
        const hiddenDays = new Set(
            this.state.hideEmptyHours === true
                ? this.daysOfWeekMatrix
                      .map((d) => d.value)
                      .filter((day) => this.isDayFullyEmpty(monthBlock, day))
                : [],
        );

        // pick a single “anchor” hour row to show the "[day] hidden" label in
        const firstVisibleHour =
            rowsToRender.find((r) => r.type === "hour")?.hour ?? 0;
        return (
            <>
                <Table
                    celled
                    structured
                    compact
                    size='small'
                    style={{ tableLayout: "fixed", width: "100%" }}
                >
                    <colgroup>
                        {/* Hour column width */}
                        <col style={{ width: 60 }} />
                        {/* Day columns width (shrink hidden days) */}
                        {this.daysOfWeekMatrix.map((d) => (
                            <col
                                key={`col-${d.value}`}
                                style={{
                                    width: hiddenDays.has(d.value)
                                        ? 80
                                        : undefined,
                                }}
                            />
                        ))}
                    </colgroup>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={8}>
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "auto 1fr auto",
                                        alignItems: "start",
                                    }}
                                >
                                    {/* Highest (left, minimal width) */}
                                    <div style={{ paddingRight: 12 }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 8,
                                            }}
                                        >
                                            <span style={{ fontWeight: 600 }}>
                                                Highest
                                            </span>
                                            <div style={{ minWidth: 180 }}>
                                                <NumberInput
                                                    decimal
                                                    icon={currencyIcon}
                                                    nullable
                                                    min={1}
                                                    iconPosition='left'
                                                    name={`highest_${month}`}
                                                    onChange={(value) =>
                                                        this.onChangeMonthHighest(
                                                            month,
                                                            value,
                                                        )
                                                    }
                                                    value={
                                                        monthBlock.highest ?? ""
                                                    }
                                                    placeholder='Highest price'
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* POA (middle, flexible) */}
                                    <div
                                        style={{
                                            paddingLeft: 12,
                                            paddingRight: 12,
                                            borderLeft:
                                                "1px solid rgba(0,0,0,0.12)",
                                            borderRight:
                                                "1px solid rgba(0,0,0,0.12)",
                                        }}
                                    >
                                        <Checkbox
                                            toggle
                                            label={
                                                monthBlock.poa === true
                                                    ? "POA (active)"
                                                    : "POA"
                                            }
                                            checked={monthBlock.poa === true}
                                            onChange={(_, { checked }) =>
                                                this.onChangeMonthPoa(
                                                    month,
                                                    checked,
                                                )
                                            }
                                        />

                                        <div style={{ marginTop: 6 }}>
                                            <small>
                                                If POA is selected, all prices
                                                for this month will appear as
                                                "POA/pp" within the MASHIE app
                                                when making a Green Fee Booking,
                                                & Green Fee Credit bookings
                                                cannot be made.
                                            </small>
                                        </div>

                                        {monthBlock.poa === true && (
                                            <div
                                                style={{
                                                    marginTop: 8,
                                                    padding: "6px 10px",
                                                    borderRadius: 6,
                                                    background:
                                                        "rgba(255, 193, 7, 0.18)",
                                                    border: "1px solid rgba(255, 193, 7, 0.6)",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                POA pricing is active for this
                                                month — table values below are
                                                not currently used but can be
                                                amended.
                                            </div>
                                        )}
                                    </div>

                                    {/* Copy month (right, minimal width) */}
                                    <div
                                        style={{
                                            paddingLeft: 12,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <Button
                                            size='mini'
                                            basic
                                            onClick={() =>
                                                this.onCopyMonth(month)
                                            }
                                            style={{
                                                padding: "4px 6px",
                                                lineHeight: 1,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Copy month
                                        </Button>
                                    </div>
                                </div>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>Hour</Table.HeaderCell>
                            {this.daysOfWeekMatrix.map((d) => (
                                <Table.HeaderCell
                                    key={d.value}
                                    style={
                                        hiddenDays.has(d.value)
                                            ? {
                                                  padding: 4,
                                                  textAlign: "center",
                                                  whiteSpace: "nowrap",
                                              }
                                            : undefined
                                    }
                                >
                                    {" "}
                                    {d.text}
                                </Table.HeaderCell>
                            ))}
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell />
                            {this.daysOfWeekMatrix.map((d) => {
                                const showGfc =
                                    this.isGroupCreditAvailableForDay(d.value);
                                const currency =
                                    this.props.club?.currency?.symbol ?? "£";
                                return (
                                    <Table.HeaderCell
                                        key={`sub-${d.value}`}
                                        style={
                                            hiddenDays.has(d.value)
                                                ? { padding: 4 }
                                                : undefined
                                        }
                                    >
                                        {" "}
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                gap: 8,
                                            }}
                                        >
                                            {hiddenDays.has(d.value) ? (
                                                <span
                                                    style={{
                                                        fontSize: 12,
                                                        opacity: 0.0,
                                                    }}
                                                >
                                                    &nbsp;
                                                </span>
                                            ) : (
                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        opacity: 0.85,
                                                        lineHeight: 1.25,
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: 12,
                                                            opacity: 0.85,
                                                            lineHeight: 1.25,
                                                        }}
                                                    >
                                                        {visibleMemberships.map(
                                                            (membership) => (
                                                                <div
                                                                    key={
                                                                        membership
                                                                    }
                                                                >
                                                                    {this.getMembershipLabelShort(
                                                                        membership,
                                                                    )}
                                                                    /{currency}
                                                                    {showGfc &&
                                                                        "/GFC"}
                                                                </div>
                                                            ),
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <Button
                                                size='mini'
                                                basic
                                                onClick={() =>
                                                    this.onCopyDayColumn(
                                                        month,
                                                        d.value,
                                                    )
                                                }
                                                style={{
                                                    padding: "4px 6px",
                                                    lineHeight: 1,
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Copy day
                                            </Button>
                                        </div>
                                    </Table.HeaderCell>
                                );
                            })}
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rowsToRender.map((row) => {
                            if (row.type === "gap") {
                                const label =
                                    row.from === row.to
                                        ? `${this.formatHourLabel(
                                              row.from,
                                          )} hidden`
                                        : `${String(row.from).padStart(
                                              2,
                                              "0",
                                          )}:00 - ${String(row.to).padStart(
                                              2,
                                              "0",
                                          )}:59 hidden`;

                                return (
                                    <Table.Row
                                        key={`gap-${row.from}-${row.to}`}
                                    >
                                        <Table.Cell
                                            colSpan={8}
                                            style={{
                                                background: "#0000ff0a",
                                                color: "rgba(0,0,0,0.55)",
                                                fontStyle: "italic",
                                                borderTop:
                                                    "1px dashed rgba(0,0,0,0.12)",
                                                borderBottom:
                                                    "1px dashed rgba(0,0,0,0.12)",
                                            }}
                                        >
                                            <small>{label}</small>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            }

                            const hour = row.hour;
                            return (
                                <Table.Row key={hour}>
                                    <Table.Cell collapsing>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                textAlign: "center",
                                            }}
                                        >
                                            <b>
                                                {this.formatHourLabel(
                                                    hour,
                                                    true,
                                                )}
                                            </b>
                                        </div>
                                    </Table.Cell>

                                    {this.daysOfWeekMatrix.map((d) => {
                                        const dayHidden =
                                            this.state.hideEmptyHours ===
                                                true && hiddenDays.has(d.value);

                                        if (dayHidden) {
                                            return (
                                                <Table.Cell
                                                    key={`${month}-${d.value}-${hour}`}
                                                    style={{
                                                        background: "#0000ff0a",
                                                        color: "rgba(0,0,0,0.55)",
                                                        borderLeft:
                                                            "1px solid rgba(0,0,0,0.06)",
                                                        borderRight:
                                                            "1px solid rgba(0,0,0,0.06)",
                                                        borderTop:
                                                            "1px solid rgba(0, 0, 255, 0.04)",
                                                        borderBottom:
                                                            "1px solid rgba(0, 0, 255, 0.04)",
                                                        position: "relative",
                                                        padding: 0,
                                                    }}
                                                >
                                                    {hour ===
                                                        firstVisibleHour && (
                                                        <div
                                                            style={{
                                                                position:
                                                                    "absolute",
                                                                inset: 0,
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                                pointerEvents:
                                                                    "none",
                                                                opacity: 0.7,
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    writingMode:
                                                                        "vertical-lr",
                                                                    fontStyle:
                                                                        "italic",
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                {d.text} hidden
                                                            </span>
                                                        </div>
                                                    )}
                                                </Table.Cell>
                                            );
                                        }
                                        const isCellEmpty =
                                            !poaActive &&
                                            this.isHourCellEmpty(
                                                monthBlock,
                                                d.value,
                                                hour,
                                            );

                                        return (
                                            <Table.Cell
                                                key={`${month}-${d.value}-${hour}`}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        opacity:
                                                            poaActive ||
                                                            isCellEmpty
                                                                ? 0.45
                                                                : 1,
                                                        background:
                                                            poaActive ||
                                                            isCellEmpty
                                                                ? "rgba(255,255,255,0.6)"
                                                                : "transparent",
                                                        borderRadius: 4,
                                                    }}
                                                >
                                                    <div>
                                                        {visibleMemberships.map(
                                                            (membership) => {
                                                                const cell =
                                                                    monthBlock?.[
                                                                        d.value
                                                                    ]?.[hour]?.[
                                                                        membership
                                                                    ];

                                                                return this.renderMembershipRow(
                                                                    {
                                                                        month,
                                                                        day: d.value,
                                                                        hour,
                                                                        membership,
                                                                        cell,
                                                                        currencyIcon,
                                                                        hasContracts,
                                                                        showCreditCheckbox:
                                                                            this.isGroupCreditAvailableForDay(
                                                                                d.value,
                                                                            ),
                                                                    },
                                                                );
                                                            },
                                                        )}
                                                    </div>

                                                    <div
                                                        style={{
                                                            marginTop: 6,
                                                            display: "flex",
                                                            justifyContent:
                                                                "flex-end",
                                                        }}
                                                    >
                                                        <Button
                                                            size='mini'
                                                            basic
                                                            onClick={() =>
                                                                this.onCopyHourCell(
                                                                    month,
                                                                    d.value,
                                                                    hour,
                                                                )
                                                            }
                                                            style={{
                                                                padding:
                                                                    "4px 6px",
                                                                lineHeight: 1,
                                                                whiteSpace:
                                                                    "nowrap",
                                                            }}
                                                        >
                                                            Copy hour
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Table.Cell>
                                        );
                                    })}
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </>
        );
    }

    listCourses() {
        if (this.state.editing !== null) {
            return;
        }

        if (this.props.club.courses.length === 0) {
            return <p className='text-center'>This club has no courses yet.</p>;
        }
        return this.props.club.courses.map((course, index) => {
            return (
                <Segment vertical key={index}>
                    <div className='row'>
                        <div className='col-10'>
                            <h4 className='mt-2'>{course.name}</h4>
                            <p className='m-0'>
                                <b>Par:</b> {course.par}
                            </p>
                            <p className='m-0'>
                                <b>Holes:</b> {course.holes}
                            </p>
                            <p className='m-0'>
                                <b>Yardage:</b> {course.yardage}
                            </p>
                            <p className='m-0'>
                                <b>Description:</b> {course.description}
                            </p>
                        </div>
                        <div className='col-2 d-flex align-items-center justify-content-end'>
                            <Button
                                primary
                                className='theme'
                                onClick={() =>
                                    this.setState({ editing: course })
                                }
                            >
                                Edit
                            </Button>
                            <Button
                                primary
                                className='red'
                                onClick={() => this.deleteCourse(index)}
                                value={index}
                            >
                                Delete
                            </Button>
                        </div>
                    </div>
                </Segment>
            );
        });
    }

    cancelEditor() {
        this.setState({ editing: null });
        this.props.dispatch(ValidationActions.remove());
    }

    onChangeGreenFee(season, day, membership, time, value) {
        const { editing } = this.state;
        editing.greenFees[season][day][membership][time] = value;
        this.setState({ editing });
    }

    onChangeHighest(season, value) {
        const { editing } = this.state;
        editing.greenFees[season].highest = value;
        this.setState({ editing });
    }

    onChangePoa(season, checked) {
        const { editing } = this.state;
        editing.greenFees[season].poa = checked;
        this.setState({ editing });
    }

    onToggle(property) {
        const { editing } = this.state;
        editing[property] = editing[property] === false;
        this.setState({ editing });
    }

    addCourseButton() {
        if (this.state.editing !== null) {
            return;
        }

        return (
            <Segment vertical>
                <Button
                    primary
                    className='theme'
                    onClick={() => this.setState({ editing: new GolfCourse() })}
                >
                    Add course
                </Button>
            </Segment>
        );
    }

    showCorrectCurrency() {
        return this.props.club?.currency?.icon ?? "";
    }

    courseEditor() {
        if (this.state.editing === null) {
            return;
        }

        return (
            <>
                <Segment vertical>
                    {this.errorsFor("name")}
                    <label className='with-input'>Course name</label>
                    <Input
                        fluid
                        name='name'
                        value={this.state.editing.name}
                        onChange={({ target }) =>
                            this.gatherInput("name", target.value)
                        }
                        placeholder='Name'
                    />
                </Segment>
                <Segment vertical>
                    {this.errorsFor("par")}
                    <label className='with-input'>Par</label>
                    <NumberInput
                        fluid
                        name='par'
                        value={this.state.editing.par}
                        onChange={(value) => this.gatherInput("par", value)}
                        placeholder='Par'
                    />
                </Segment>
                <Segment vertical>
                    {this.errorsFor("holes")}
                    <label className='with-input'>Holes</label>
                    <NumberInput
                        fluid
                        name='holes'
                        value={this.state.editing.holes}
                        onChange={(value) => this.gatherInput("holes", value)}
                        placeholder='Holes'
                    />
                </Segment>
                <Segment vertical>
                    {this.errorsFor("yardage")}
                    <label className='with-input'>Yardage</label>
                    <NumberInput
                        fluid
                        name='yardage'
                        value={this.state.editing.yardage}
                        onChange={(value) => this.gatherInput("yardage", value)}
                        placeholder='Yardage'
                    />
                </Segment>
                <Segment vertical>
                    {this.errorsFor("description")}
                    <label className='with-input'>Description</label>
                    <Form>
                        <TextArea
                            name='description'
                            value={this.state.editing.description}
                            onChange={({ target }) =>
                                this.gatherInput("description", target.value)
                            }
                            placeholder='Decription'
                        />
                    </Form>
                </Segment>

                <Segment vertical>
                    <h3>Corporate group</h3>

                    <div className='row'>
                        {/* Left: existing content */}
                        <div className='col-12 col-md-7'>
                            <p style={{ marginBottom: 12 }}>
                                Courses must be attached to a corporate group to
                                accept Green Fee Credit bookings. Set a group to
                                choose Green Fee Credit availability.
                            </p>

                            <GroupSearchSelect
                                placeholder='Select a group'
                                value={this.state.editing.group?._id ?? null}
                                onChange={(value, availability) => {
                                    this.setState((prev) => {
                                        const next = new GolfCourse(
                                            prev.editing,
                                        ); // preserves methods
                                        next.group = {
                                            ...(next.group ?? {}),
                                            _id: value,
                                            availability,
                                        };
                                        return { editing: next };
                                    });
                                }}
                            />

                            {this.state.editing.group?._id && (
                                <div style={{ marginTop: 8, display: "flex" }}>
                                    <Button
                                        size='small'
                                        basic
                                        as='a'
                                        href={`/course-groups/${this.state.editing.group._id}`}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        View group
                                    </Button>
                                </div>
                            )}
                        </div>

                        {/* Right: availability table */}
                        <div className='col-12 col-md-5'>
                            {this.state.editing.group?._id ? (
                                <>
                                    <div
                                        style={{
                                            fontWeight: 600,
                                            marginBottom: 8,
                                        }}
                                    >
                                        Group availability
                                    </div>

                                    <Table celled compact size='small'>
                                        <Table.Body>
                                            {this.daysOfWeekMatrix.map((d) => {
                                                const key =
                                                    d.text.toLowerCase(); // monday, tuesday...
                                                const value =
                                                    this.state.editing.group
                                                        ?.availability?.[key];

                                                return (
                                                    <Table.Row key={d.value}>
                                                        <Table.Cell
                                                            collapsing
                                                            style={{
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {d.text}
                                                        </Table.Cell>
                                                        <Table.Cell textAlign='right'>
                                                            {typeof value ===
                                                            "number"
                                                                ? value
                                                                : "—"}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                );
                                            })}
                                        </Table.Body>
                                    </Table>

                                    <small style={{ opacity: 0.75 }}>
                                        Days with 0 as the availability will
                                        hide the Green Fee Credit checkbox from
                                        that day in the pricing matrix for every
                                        month.
                                    </small>
                                </>
                            ) : (
                                <small style={{ opacity: 0.75 }}>
                                    Select a group to view availability by day.
                                </small>
                            )}
                        </div>
                    </div>
                </Segment>

                {this.state.editing.group && (
                    <>
                        <Segment vertical>
                            <h3>Contracts</h3>
                            {this.state.editing.contracts.length === 0 ? (
                                <>
                                    <p className='mt-3'>
                                        <b>
                                            Courses must be attached to a
                                            contract to accept Green Fee Credit
                                            bookings. Add a contract to choose
                                            Green Fee Credit availability.
                                        </b>
                                    </p>
                                    <Link to='/partner-club-contracts/create'>
                                        <Button primary className='theme'>
                                            Create contract
                                        </Button>
                                    </Link>
                                </>
                            ) : (
                                <>
                                    {this.state.editing.contracts.map(
                                        (item) => {
                                            const contract =
                                                new PartnerClubContract(item);
                                            return (
                                                <div className='mt-3'>
                                                    <Link
                                                        className='mr-2'
                                                        to={`/partner-club-contracts/${contract._id}`}
                                                    >
                                                        {contract.name}
                                                    </Link>
                                                    {contract.statusLabel}
                                                    <span className='ml-3'>
                                                        Activation:{" "}
                                                        {format(
                                                            item.activatesAt,
                                                            "dd/MM/yyyy",
                                                        )}
                                                    </span>
                                                    <span className='ml-3'>
                                                        Expiry:{" "}
                                                        {format(
                                                            item.expiresAt,
                                                            "dd/MM/yyyy",
                                                        )}
                                                    </span>
                                                </div>
                                            );
                                        },
                                    )}
                                </>
                            )}
                        </Segment>
                        <Segment vertical>
                            <h3>GFC Visibility</h3>
                            <div style={{ marginBottom: 12, marginTop: 12 }}>
                                <Checkbox
                                    toggle
                                    label='Would you like this course to be visible to members on the app for them to make bookings using their Green Fee Credit? You will still need to maintain the GFC pricing checboxes in the pricing matrix to allow contract bookings & voucher bookings to be made on the control panel and app.'
                                    checked={
                                        this.state.editing.GFCVisibility ===
                                        true
                                    }
                                    onChange={(_, { checked }) =>
                                        this.gatherInput(
                                            "GFCVisibility",
                                            checked === true,
                                        )
                                    }
                                />
                            </div>
                        </Segment>
                    </>
                )}

                <h3>Green Fee Pricing</h3>
                <p>
                    Allocate a price to each time slot. If no price is provided,
                    the time slot will not be bookable. You will not be able to
                    enter "0" as a price. If you wish to prevent the slot from
                    being booked, do not enter a value.
                </p>

                <div style={{ marginBottom: 12, marginTop: 12 }}>
                    <Checkbox
                        toggle
                        label='Hide empty hours & days'
                        checked={this.state.hideEmptyHours === true}
                        onChange={(_, { checked }) =>
                            this.setState({ hideEmptyHours: checked === true })
                        }
                    />
                </div>

                <Tabs
                    activeKey={this.state.activePricingMonth}
                    onSelect={(k) =>
                        this.setState({ activePricingMonth: Number(k) })
                    }
                    id='pricingMatrixTabs'
                    className='mb-3'
                >
                    {this.months.map((m) => (
                        <Tab eventKey={m.value} title={m.text} key={m.value} />
                    ))}
                </Tabs>

                {this.renderMonthPricingMatrix(this.state.activePricingMonth)}

                <Segment vertical className='text-right'>
                    <Button
                        primary
                        className='theme'
                        onClick={this.confirmCourse.bind(this)}
                        disabled={this.state.saving}
                        loading={this.state.saving}
                    >
                        Save
                    </Button>
                    <Button onClick={this.cancelEditor.bind(this)}>
                        Cancel
                    </Button>
                </Segment>
            </>
        );
    }

    confirmCourse() {
        const { club } = this.props;
        const { editing } = this.state;
        this.setState({ saving: true });

        if (typeof editing._id === "undefined") {
            editing
                .store(this.props.club._id)
                .then((result) => {
                    const course = new GolfCourse(result.data.data);
                    club.courses.push(course);
                    this.setState({ editing: null, saving: false });
                    this.notification("success", "Course saved");
                    this.props.update(club);
                })
                .catch((error) => {
                    this.setState({ saving: false });
                    this.notification(
                        "error",
                        "Failed to save course, please try again",
                    );
                    this.handleValidationErrors(error);
                });
        } else {
            const index = club.courses.findIndex(
                (course) => course._id === editing._id,
            );
            editing
                .update(this.props.club._id)
                .then((result) => {
                    const course = new GolfCourse(result.data.data);
                    club.courses.splice(index, 1, course);
                    this.setState({ editing: null, saving: false });
                    this.notification("success", "Course updated");
                    this.props.update(club);
                })
                .catch((error) => {
                    this.setState({ saving: false });
                    this.notification(
                        "error",
                        "Failed to save course, please try again",
                    );
                    this.handleValidationErrors(error);
                });
        }
    }

    render() {
        return (
            <>
                {this.courseEditor()}
                {this.listCourses()}
                {this.addCourseButton()}
                {this.renderCopyHourModal()}
                {this.renderCopyDayModal()}
                {this.renderCopyMonthModal()}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        notification: state.notification,
        validation: state.validation,
    };
}

export default connect(mapStateToProps)(Courses);
